import Service from "../DepartmentService";

function GetByDepartmentId() {
    return Service.get('DegreeAndCertificate');
}

const DegreeAndCertificateService = {
    GetByDepartmentId
};

export default DegreeAndCertificateService;
